import React from 'react';
import { Handle, Position } from 'reactflow';
export const BranchNode = ({ data, selected, id }) => {

  return (
    <div className="react-flow__node-default" style={{ height: '100px' }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ 
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="condition-label">
        <label style={{ display: 'block' }}>Relations Branch</label>
      </div>

      <div style={{ padding: 20, paddingTop: 0, paddingBottom: 0 }}>
      </div>

      <Handle
        className="handle-neutral"
        type="source"
        position={Position.Right}
        id="neutral"
        style={{
          right: 0,
          top: '25%',
          transform: 'translateY(-50%)'
        }}
      />
      <div style={{
        position: 'absolute',
        right: 25,
        top: '25%',
        transform: 'translateY(-50%)',
        fontSize: '12px',
        color: '#666'
      }}>
        Neutral
      </div>
      
      <Handle
        className="handle-trusting"
        type="source"
        position={Position.Right}
        id="trusting"
        style={{
          right: 0,
          top: '45%',
          transform: 'translateY(-50%)'
        }}
      />
      <div style={{
        position: 'absolute',
        right: 25,
        top: '45%',
        transform: 'translateY(-50%)',
        fontSize: '12px',
        color: '#666'
      }}>
        Trusting
      </div>

      <Handle
        className="handle-obedient"
        type="source"
        position={Position.Right}
        id="obedient"
        style={{
          right: 0,
          top: '65%',
          transform: 'translateY(-50%)'
        }}
      />
      <div style={{
        position: 'absolute',
        right: 25,
        top: '65%',
        transform: 'translateY(-50%)',
        fontSize: '12px',
        color: '#666'
      }}>
        Obedient
      </div>

      <Handle
        className="handle-devoted"
        type="source"
        position={Position.Right}
        id="devoted"
        style={{
          right: 0,
          top: '85%',
          transform: 'translateY(-50%)'
        }}
      />
      <div style={{
        position: 'absolute',
        right: 25,
        top: '85%',
        transform: 'translateY(-50%)',
        fontSize: '12px',
        color: '#666'
      }}>
        Devoted
      </div>
    </div>
  );
};